import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';

export function LoginPage() {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      await instance.loginRedirect(loginRequest);
    } catch (e: any) {
      if (e.errorCode !== 'user_cancelled') {
        setError('Sign-in failed. Please try again or contact IT support.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:       '100vh',
      background:      'linear-gradient(135deg, #1a2744 0%, #2e4080 50%, #1a2744 100%)',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      fontFamily:      'var(--font)',
      padding:         24,
    }}>
      {/* Background pattern */}
      <div style={{
        position:  'fixed', inset: 0, opacity: 0.04,
        backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
        backgroundSize:  '32px 32px',
        pointerEvents:   'none',
      }} />

      <div style={{
        background:    '#fff',
        borderRadius:  20,
        padding:       '48px 40px',
        width:         '100%',
        maxWidth:      420,
        boxShadow:     '0 20px 60px rgba(0,0,0,0.3)',
        textAlign:     'center',
        position:      'relative',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, background: 'var(--navy)',
            borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div style={{
              width: 24, height: 24, background: 'var(--gold)',
              borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1v12M1 7h12" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </div>
          </div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--navy)', marginBottom: 6 }}>
          IT Project Portal
        </h1>
        <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 8 }}>
          The Woodlands Township
        </p>
        <div style={{
          width: 40, height: 2, background: 'var(--gold)',
          margin: '0 auto 28px', borderRadius: 1,
        }} />

        <p style={{ fontSize: 14, color: 'var(--text2)', marginBottom: 28, lineHeight: 1.6 }}>
          Sign in with your Township Microsoft account to submit and track IT project requests.
        </p>

        {error && (
          <div style={{
            background: 'var(--danger-bg)', border: '1px solid var(--danger)',
            color: 'var(--danger-text)', borderRadius: 8, padding: '10px 14px',
            fontSize: 13, marginBottom: 16, textAlign: 'left',
          }}>
            {error}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width:        '100%',
            padding:      '12px 24px',
            background:   loading ? '#a0b4d0' : 'var(--accent)',
            color:        '#fff',
            border:       'none',
            borderRadius: 10,
            fontSize:     15,
            fontWeight:   600,
            fontFamily:   'var(--font)',
            cursor:       loading ? 'not-allowed' : 'pointer',
            display:      'flex',
            alignItems:   'center',
            justifyContent: 'center',
            gap:          10,
            transition:   'background 0.15s',
          }}
        >
          {loading ? (
            <>
              <div style={{
                width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)',
                borderTopColor: '#fff', borderRadius: '50%',
                animation: 'spin 0.6s linear infinite',
              }} />
              Signing in...
            </>
          ) : (
            <>
              {/* Microsoft logo */}
              <svg width="18" height="18" viewBox="0 0 18 18">
                <rect x="1" y="1" width="7.5" height="7.5" fill="#f25022"/>
                <rect x="9.5" y="1" width="7.5" height="7.5" fill="#7fba00"/>
                <rect x="1" y="9.5" width="7.5" height="7.5" fill="#00a4ef"/>
                <rect x="9.5" y="9.5" width="7.5" height="7.5" fill="#ffb900"/>
              </svg>
              Sign in with Microsoft
            </>
          )}
        </button>

        <p style={{ fontSize: 11, color: 'var(--text3)', marginTop: 20 }}>
          Use your @thewoodlandstownship-tx.gov account
        </p>
      </div>
    </div>
  );
}
